import React, { useState, useEffect, useRef } from 'react';

import Link from 'next/link'



const EardCTA = () => {


    return (
        <>

            {/* Booking CTA */}
            <section className="bg-blue-500 lg:py-48 py-24">
                <div className="max-w-screen-2xl mx-auto sm:px-10 px-8 grid lg:grid-cols-2 grid-cols-1 items-center">
                    <div className="col-span-1">
                        <h2 className="md:text-5xl text-3xl font-medium leading-snug text-white">Become a PMHA member</h2>
                        <p className="text-2xl text-white mb-5 max-w-[500px] font-CantoraOne">Be part of our roster volunteers and professional and company partners!</p>
                        <p className="text-sm text-gray-300">Available for Regular: Corporate (Corporations and Big Companies), Sustaining (Government and Non-Government Organizations and Agencies), Life (Individual) and Contributing (Professionals); Associate: Students (College, Senior High School, Junior High School, and Elementary)</p>
                    </div>
                    <div className="col-span-1">
                        <div className="text-2xl sm:text-3xl text-center lg:mt-0 mt-8">
                            <Link href="/membership"><a className="btn btn-secondary font-CantoraOne rounded-full py-4 px-10">Join our advocacy!</a></Link>
                        </div>
                    </div>
                </div>
            </section>


            
            
        </>


    )
}

export default EardCTA;